import React from 'react';
import { ChevronDown, Plus } from 'lucide-react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@roger/ui-components';

export type AddMedicationMode = 'standard' | 'nonstandard' | 'offmarket';

interface AddMedicationButtonProps {
  onSelect: (mode: AddMedicationMode) => void;
}

const AddMedicationButton: React.FC<AddMedicationButtonProps> = ({
  onSelect,
}) => {
  return (
    <div className='flex'>
      <Button onClick={() => onSelect('standard')} className='rounded-r-none'>
        <Plus className='h-4 w-4 mr-2' />
        Add Medication
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className='rounded-l-none border-l border-primary-foreground/20 px-2'>
            <ChevronDown className='h-4 w-4' />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end'>
          <DropdownMenuItem onClick={() => onSelect('standard')}>
            Standard Dosage
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onSelect('nonstandard')}>
            Nonstandard Dosage
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onSelect('offmarket')}>
            Off Market / Unlisted
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default AddMedicationButton;
